const FORMULA_TRIGGER_CHARS = new Set(["=", "+", "-", "@", "\t", "\r"]);

/**
 * Neutralizes CSV/Excel formula injection: a cell value starting with =, +, -, @,
 * tab, or CR can be interpreted as a formula by spreadsheet apps. Prefixing with an
 * apostrophe forces plain-text interpretation while keeping the value readable.
 */
export function sanitizeExcelCell(value: string): string {
	if (value.length > 0 && FORMULA_TRIGGER_CHARS.has(value[0])) {
		return `'${value}`;
	}
	return value;
}
